define('components/multi-step',[
    "jquery",
    "storage",
    "logging",
    "application"
], function($, storage, logging, app) {
    "use strict";

    var _ModuleName = "Multi-Step Page";
    var _config = {
        currentStep: 1,
        totalSteps: 1,
        storage: {
            formData: "multi-step-"
        },
        hiddenFields: [
            "track1",
            "campaignid"
        ]
    };

    var init = function(data) {
        _config.currentStep = typeof(data.currentStep) !== 'undefined' ? data.currentStep : _config.currentStep;
        _config.totalSteps = typeof(data.totalSteps) !== 'undefined' ? data.totalSteps : _config.totalSteps;

        // if we're running in pathfinder, carry frame config through all steps
        if (app.runningInPathfinder()) {
            // on page 1, store app config in session storage
            if (_config.currentStep == 1) {
                app.storeFrameConfigInSessionStorage();
            }

            // if we're on the last step, clean up storage
            if (_isFinalStep()) {
                app.clearFrameConfigFromSessionStorage();
            }
        }
    }

    var run = function() {

        logging.debug("Enabling Multi-Step Capabilities [" +_config.currentStep+ " of " + _config.totalSteps + "]", _ModuleName);

        // get handle on form
        var $form = window.lp && window.lp.jQuery && typeof(window.lp.jQuery) != 'undefined' 
            ? window.lp.jQuery('.lp-pom-form form')
            : $('.lp-pom-form form');
        if ($form.length > 0) {
            if (_isFinalStep()) {
                logging.debug("This is the final step. Loading all data into hidden fields.", _ModuleName);

                // need to populate hidden fields with data we've captured
                for (var step = 1; step < _config.totalSteps; step++) {
                    // get data for step
                    var data = JSON.parse(storage.getSessionStorage(_config.storage.formData + step));

                    if (data) {
                        // populate any associated hidden fields
                        for( var index = 0; index < data.length; index++) {
                            var field = data[index];
                            var query = ':input[type="hidden"][name="' + field.name + '"]';
                            var frmField = $form.find(query);
                            if(frmField.length == 1) {
                                // Only update if we actually have some data
                                if (field.value) {
                                    logging.debug("Setting field '" + field.name + "' to '" + field.value + "'", _ModuleName);
                                    logging.debug("Query used: " + query, _ModuleName);
                                    frmField.val(field.value);
                                }
                            } else if (frmField.length > 1) {
                                logging.warn("Found " + frmField.length + " fields using query '" + query + "'. No updates made.", _ModuleName);
                            } else {
                                logging.warn("Could not find hidden field '" + field.name + "'", _ModuleName);
                            }
                        }
                    } else {
                        logging.warn("No data found for step " + step);
                    }
                }
            } else {
                logging.debug("Not final step. Configuring to pull form data.", _ModuleName);

                var query = ':input:not([type=hidden])';

                if (_config.currentStep == 1) {
                    for (var q = 0; q < _config.hiddenFields.length; q++) {
                        query += ', :input[name=' + _config.hiddenFields[q] + ']';
                    }
                }
                logging.debug("Form Element Query: " + query, _ModuleName);
                
                // need to capture new fields when user moves to next step
                var $submit = $('.lp-pom-button');
                $submit.click(function (e) {
                    // capture data
                    var data = JSON.stringify($form.find(query).serializeArray());

                    console.log("Data Saved: " , data);

                    // store data
                    storage.setSessionStorage(_config.storage.formData + _config.currentStep, data);
                });
            }
        }
    }

    var _isFinalStep = function() {
        return _config.currentStep === _config.totalSteps;
    }

    return {
        init: init,
        run: run
    }
});
